/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessCategoryLv2
 */
export interface BusinessCategoryLv2 {
    /**
     * メインビジネスカテゴリID
     * @type {string}
     * @memberof BusinessCategoryLv2
     */
    busiCateId: string;
    /**
     * サブビジネスカテゴリID
     * @type {number}
     * @memberof BusinessCategoryLv2
     */
    busiCateLv2Id: number;
    /**
     * サブビジネスカテゴリ名
     * @type {string}
     * @memberof BusinessCategoryLv2
     */
    busiCateLv2Name: string;
    /**
     * 配信したプレスリリース数
     * @type {number}
     * @memberof BusinessCategoryLv2
     */
    releaseCount: number;
}

export function BusinessCategoryLv2FromJSON(json: any): BusinessCategoryLv2 {
    return BusinessCategoryLv2FromJSONTyped(json, false);
}

export function BusinessCategoryLv2FromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessCategoryLv2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'busiCateId': json['busi_cate_id'],
        'busiCateLv2Id': json['busi_cate_lv2_id'],
        'busiCateLv2Name': json['busi_cate_lv2_name'],
        'releaseCount': json['release_count'],
    };
}

export function BusinessCategoryLv2ToJSON(value?: BusinessCategoryLv2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'busi_cate_id': value.busiCateId,
        'busi_cate_lv2_id': value.busiCateLv2Id,
        'busi_cate_lv2_name': value.busiCateLv2Name,
        'release_count': value.releaseCount,
    };
}

